import { DonutChart } from '@carbon/charts-react';

import styles from 'theme/features/dashboard/components/breakdown-donut-chart.module.scss';

const BreakdownDonutChart = ({ data, title, colors, compact, formatTooltip = undefined }) => {
  const options = {
    resizable: false,
    height: compact ? '300px' : '400px',
    legend: {
      enabled: !colors,
      truncation: {
        numCharacter: 100
      }
    },
    tooltip: {
      valueFormatter: formatTooltip,
      truncation: {
        numCharacter: 100
      }
    },
    toolbar: {
      enabled: false
    },
    data: {
      loading: !data
    },
    donut: {
      alignment: 'center'
    },
    colors: {
      scale: colors
    },
    getFillColor: colors ? (group) => colors[group] : undefined
  };

  return (
    <div className={styles.wrapper}>
      {title && (
        <h4>
          <strong>{title}</strong>
        </h4>
      )}
      <DonutChart options={options} data={data ?? []} />
    </div>
  );
};

export default BreakdownDonutChart;
